import { useEffect } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { DashboardRoutes } from './DashboardRoutes';
import { PublicRoutes } from './PublicRoutes';
import { startLogout } from '../store/auth';
import { localizePathname, normalizeRouteLanguage } from '../routes/localizedRoutes';

export const AppRouter = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { i18n } = useTranslation();
  const { status } = useSelector((state) => state.auth);

  let cookieToCheck = '';

  const cookieToken = document.cookie
    .split('; ')
    .find((row) => row.startsWith('token'))
    ?.split('=')[1];

  cookieToCheck = cookieToken;

  const cookiesPetroprix = document.cookie
    .split('; ')
    .filter((row) => row.startsWith('petroprix'));

  if (cookiesPetroprix.length > 0) {
    cookiesPetroprix.forEach((cookie) => {
      cookieToCheck += cookie.split('=')[1];
    });
  }

  useEffect(() => {
    if (
      cookieToCheck !== '' &&
      cookieToCheck !== undefined &&
      cookieToCheck !== null &&
      cookieToCheck !== false
    ) {
      const payload = JSON.parse(atob(cookieToCheck?.split('.')[1]));
      if (payload.exp < Date.now() / 1000) {
        document.cookie =
          'token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';

        if (cookiesPetroprix.length > 0) {
          cookiesPetroprix.forEach((cookie) => {
            document.cookie = `${
              cookie.split('=')[0]
            }=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
          });
        }

        dispatch(startLogout('expired'));
      }
    }
  }, [cookieToCheck, cookiesPetroprix, dispatch, status]);

  const language = normalizeRouteLanguage(
    i18n.resolvedLanguage || i18n.language,
  );
  const localizedPathname = localizePathname(location.pathname, language);

  if (location.pathname !== '/' && localizedPathname !== location.pathname) {
    return (
      <Navigate
        replace
        state={location.state}
        to={{
          pathname: localizedPathname,
          search: location.search,
          hash: location.hash,
        }}
      />
    );
  }

  return (
    <Routes>
      {status === 'authenticated' ? (
        <Route path='/*' element={<DashboardRoutes />} />
      ) : (
        <Route path='/*' element={<PublicRoutes />} />
      )}
    </Routes>
  );
};
